export type BlogPost = {
  id: string
  title_en: string // Add English title
  title_tr: string // Add Turkish title
  excerpt: string
  excerpt_en: string // Add English excerpt
  excerpt_tr: string // Add Turkish excerpt
  date: string
  slug_tr: string
  slug_en: string
  category: string
  author: string
  coverImage: string
}

export const blogPosts: BlogPost[] = [
  {
    id: '1',
    slug_tr: 'hmi-nedir',
    slug_en: 'whats-hmi',
    title_en: 'WHAT IS HMI?',
    title_tr: 'HMI NEDİR?',
    date: '2024-04-12',
    category: 'Automation',
    author: 'Mekanet Team',
    excerpt:
      'Gelişen teknolojinin etkisiyle birlikte otomasyon sektöründe üretim süreçlerini daha güvenli ve verimli hale getiren bileşenler ortaya çıkmıştır. Bu bileşenlerden biri de kısaca “HMI” olarak bilinmektedir.',
    excerpt_en:
      'With the effect of developing technology, components that make production processes safer and more efficient have emerged in the automation sector. One of these components is briefly known as “HMI”.',
    excerpt_tr:
      'Gelişen teknolojinin etkisiyle birlikte otomasyon sektöründe üretim süreçlerini daha güvenli ve verimli hale getiren bileşenler ortaya çıkmıştır. Bu bileşenlerden biri de kısaca “HMI” olarak bilinmektedir.',
    coverImage: '/assets/images/new/blog-hmi.jpeg',
  },
  {
    id: '2',
    slug_tr: 'durum-izleme',
    slug_en: 'condition-monitoring',
    title_en: 'CONDITION MONITORING',
    title_tr: 'DURUM İZLEME',
    date: '2025-05-13',
    category: 'Automation',
    author: 'Mekanet Team',
    excerpt:
      'Endüstriyel tesislerde makinelerin ve ekipmanların durup dururken arızalanması hem maliyetli hem de zaman kaybettirici olabilir. Ancak bu tür sorunların önüne geçmenin oldukça etkili bir yolu var: Durum İzleme.',
    excerpt_en:
      'In industrial facilities, the sudden failure of machines and equipment can be both costly and time-consuming. However, there is a very effective way to prevent such problems: Condition Monitoring.',
    excerpt_tr:
      'Endüstriyel tesislerde makinelerin ve ekipmanların durup dururken arızalanması hem maliyetli hem de zaman kaybettirici olabilir. Ancak bu tür sorunların önüne geçmenin oldukça etkili bir yolu var: Durum İzleme.',
    coverImage: '/assets/images/new/blog-monitoring.jpeg',
  },
  {
    id: '3',
    slug_tr: 'kestirimci-bakim',
    slug_en: 'predictive-maintenance',
    title_en: 'PREDICTIVE MAINTENANCE',
    title_tr: 'KESTİRİMCİ BAKIM',
    date: '2025-05-13',
    category: 'Automation',
    author: 'Mekanet Team',
    excerpt:
      'Geleneksel bakım anlayışından daha akıllı, daha öngörülü ve daha az maliyetli bir sisteme geçiş yapmak artık mümkün. Endüstriyel dünyada verimliliği artırmanın ve plansız duruşları en aza indirmenin anahtarı, kestirimci bakım ve bunun arkasındaki güçlü teknoloji olan makine öğrenimi ile mümkün hale geliyor.',
    excerpt_en:
      'It is now possible to switch from the traditional maintenance approach to a smarter, more predictive, and less costly system. The key to increasing efficiency and minimizing unplanned downtime in the industrial world is made possible by predictive maintenance and the powerful technology behind it, machine learning.',
    excerpt_tr:
      'Geleneksel bakım anlayışından daha akıllı, daha öngörülü ve daha az maliyetli bir sisteme geçiş yapmak artık mümkün. Endüstriyel dünyada verimliliği artırmanın ve plansız duruşları en aza indirmenin anahtarı, kestirimci bakım ve bunun arkasındaki güçlü teknoloji olan makine öğrenimi ile mümkün hale geliyor.',
    coverImage: '/assets/images/new/blog-predictive.jpeg',
  },
]
